import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.667\" clip-path=\"url(#a)\"><path d=\"M1.667 10A8.333 8.333 0 0 0 10 18.332a2.5 2.5 0 0 0 2.5-2.5v-.417c0-.387 0-.58.022-.743a2.5 2.5 0 0 1 2.152-2.152c.162-.022.356-.022.743-.022h.417a2.5 2.5 0 0 0 2.5-2.5 8.333 8.333 0 0 0-16.667 0\"></path><path d=\"M5.834 10.833a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M13.334 7.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.666M8.334 6.666a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h20v20H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }